export const FETCH_CALENDAR_START = 'FETCH_CALENDAR_START';
export const FETCH_CALENDAR_FULFILLED = 'FETCH_CALENDAR_FULFILLED';
export const FETCH_CALENDAR_REJECTED = 'FETCH_CALENDAR_REJECTED';

export const FETCH_CURRENT_USER_START = 'FETCH_CURRENT_USER_START ';
export const FETCH_CURRENT_USER_FULFILLED = 'FETCH_CURRENT_USER_FULFILLED';
export const FETCH_CURRENT_USER_REJECTED = 'FETCH_CURRENT_USER_REJECTED';

export const FETCH_RECURRING_CALENDAR_ITEMS_START = 'FETCH_RECURRING_CALENDAR_ITEMS_START';
export const FETCH_RECURRING_CALENDAR_ITEMS_FULFILLED = 'FETCH_RECURRING_CALENDAR_ITEMS_FULFILLED';
export const FETCH_RECURRING_CALENDAR_ITEMS_REJECTED = 'FETCH_RECURRING_CALENDAR_ITEMS_REJECTED';

export const FETCH_PARENT_CALENDARS_START = 'FETCH_PARENT_CALENDARS_START';
export const FETCH_PARENT_CALENDARS_FULFILLED = 'FETCH_PARENT_CALENDARS_FULFILLED';
export const FETCH_PARENT_CALENDARS_REJECTED = 'FETCH_PARENT_CALENDARS_REJECTED';

export const DELETE_SAVED_CALENDAR_ITEM_START = 'DELETE_SAVED_CALENDAR_ITEM_START';
export const DELETE_SAVED_CALENDAR_ITEM_FULFILLED = 'DELETE_SAVED_CALENDAR_ITEM_FULFILLED';
export const DELETE_SAVED_CALENDAR_ITEM_REJECTED = 'DELETE_SAVED_CALENDAR_ITEM_REJECTED';

export const DELETE_SAVED_WORKOUT_ITEM_START = 'DELETE_SAVED_WORKOUT_ITEM_START';
export const DELETE_SAVED_WORKOUT_ITEM_FULFILLED = 'DELETE_SAVED_WORKOUT_ITEM_FULFILLED';
export const DELETE_SAVED_WORKOUT_ITEM_REJECTED = 'DELETE_SAVED_WORKOUT_ITEM_REJECTED';

export const DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_START = 'DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_START';
export const DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_FULFILLED = 'DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_FULFILLED';
export const DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_REJECTED = 'DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_REJECTED';

export const UPDATE_CALENDAR_ITEMS_ORDER_START = 'UPDATE_CALENDAR_ITEMS_ORDER_START';
export const UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED = 'UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED';
export const UPDATE_CALENDAR_ITEMS_ORDER_REJECTED = 'UPDATE_CALENDAR_ITEMS_ORDER_REJECTED';

export const UPDATE_WORKOUT_ITEMS_ORDER_START = 'UPDATE_WORKOUT_ITEMS_ORDER_START';
export const UPDATE_WORKOUT_ITEMS_ORDER_FULFILLED = 'UPDATE_WORKOUT_ITEMS_ORDER_FULFILLED';
export const UPDATE_WORKOUT_ITEMS_ORDER_REJECTED = 'UPDATE_WORKOUT_ITEMS_ORDER_REJECTED';

export const MOVE_EXERCISE_BETWEEN_DATES_START = 'MOVE_EXERCISE_BETWEEN_DATES_START';
export const MOVE_EXERCISE_BETWEEN_DATES_FULFILLED = 'MOVE_EXERCISE_BETWEEN_DATES_FULFILLED';
export const MOVE_EXERCISE_BETWEEN_DATES_REJECTED = 'MOVE_EXERCISE_BETWEEN_DATES_REJECTED';

export const MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_START = 'MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_START';
export const MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_FULFILLED = 'MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_FULFILLED';
export const MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_REJECTED = 'MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_REJECTED';

export const CONVERT_RECURRING_ITEM_START = 'CONVERT_RECURRING_ITEM_START';
export const CONVERT_RECURRING_ITEM_FULFILLED = 'CONVERT_RECURRING_ITEM_FULFILLED';
export const CONVERT_RECURRING_ITEM_REJECTED = 'CONVERT_RECURRING_ITEM_REJECTED';

export const UPDATE_RECURRING_ITEM_SCHEDULE_START = 'UPDATE_RECURRING_ITEM_SCHEDULE_START';
export const UPDATE_RECURRING_ITEM_SCHEDULE_FULFILLED = 'UPDATE_RECURRING_ITEM_SCHEDULE_FULFILLED';
export const UPDATE_RECURRING_ITEM_SCHEDULE_REJECTED = 'UPDATE_RECURRING_ITEM_SCHEDULE_REJECTED';

export const SAVE_CALENDAR_EXERCISE_START = 'SAVE_CALENDAR_EXERCISE_START';
export const SAVE_CALENDAR_EXERCISE_FULFILLED = 'SAVE_CALENDAR_EXERCISE_FULFILLED';
export const SAVE_CALENDAR_EXERCISE_REJECTED = 'SAVE_CALENDAR_EXERCISE_REJECTED';

export const SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_START = 'SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_START';
export const SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED = 'SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED';
export const SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_REJECTED = 'SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_REJECTED';

export const FETCH_CAL_WORKOUT_CALENDAR_START = 'FETCH_CAL_WORKOUT_CALENDAR_START';
export const FETCH_CAL_WORKOUT_CALENDAR_FULFILLED = 'FETCH_CAL_WORKOUT_CALENDAR_FULFILLED';
export const FETCH_CAL_WORKOUT_CALENDAR_REJECTED = 'FETCH_CAL_WORKOUT_CALENDAR_REJECTED';

export const FETCH_CALENDAR_SELECT_ATHLETES_START = 'FETCH_CALENDAR_SELECT_ATHLETES_START';
export const FETCH_CALENDAR_SELECT_ATHLETES_FULFILLED = 'FETCH_CALENDAR_SELECT_ATHLETES_FULFILLED';
export const FETCH_CALENDAR_SELECT_ATHLETES_REJECTED = 'FETCH_CALENDAR_SELECT_ATHLETES_REJECTED';

export const UPDATE_PROGRAMMED_CALENDAR_ITEM_START = 'UPDATE_PROGRAMMED_CALENDAR_ITEM_START';
export const UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED = 'UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED';
export const UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED = 'UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED';

export const UPDATE_SAVED_WORKOUT_ITEM_START = 'UPDATE_SAVED_WORKOUT_ITEM_START';
export const UPDATE_SAVED_WORKOUT_ITEM_FULFILLED = 'UPDATE_SAVED_WORKOUT_ITEM_FULFILLED';
export const UPDATE_SAVED_WORKOUT_ITEM_REJECTED = 'UPDATE_SAVED_WORKOUT_ITEM_REJECTED';

export const SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_START = 'SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_START';
export const SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED = 'SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED';
export const SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_REJECTED = 'SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_REJECTED';

export const REVERT_SWAPPED_ITEM_START = 'REVERT_SWAPPED_ITEM_START';
export const REVERT_SWAPPED_ITEM_FULFILLED = 'REVERT_SWAPPED_ITEM_FULFILLED';
export const REVERT_SWAPPED_ITEM_REJECTED = 'REVERT_SWAPPED_ITEM_REJECTED';

export const UPDATE_PRESAVED_CALENDAR_ITEM = 'UPDATE_PRESAVED_CALENDAR_ITEM';
export const UPDATE_PRESAVED_PROGRAM_ITEM = 'UPDATE_PRESAVED_PROGRAM_ITEM';

export const SET_IS_PRIMARY_ANIMATED_SIDE_BAR_OPEN = 'SET_IS_PRIMARY_ANIMATED_SIDE_BAR_OPEN';
export const SET_PRIMARY_SIDE_BAR_DATA_TAG = 'SET_PRIMARY_SIDE_BAR_DATA_TAG';
export const SET_SECONDARY_SIDE_BAR_DATA_TAG = 'SET_SECONDARY_SIDE_BAR_DATA_TAG';
export const SET_ACTIVE_MODAL = 'SET_ACTIVE_MODAL';
export const SET_ACTIVE_SECOND_LAYER_MODAL = 'SET_ACTIVE_SECOND_LAYER_MODAL';
export const SET_SELECTED_REDUX_CALENDAR = 'SET_SELECTED_REDUX_CALENDAR';
export const SET_SELECTED_REDUX_NON_DATE_BASED_PROGRAM = 'SET_SELECTED_REDUX_NON_DATE_BASED_PROGRAM';
export const SET_IS_CLONE_DRAGGING = 'SET_IS_CLONE_DRAGGING';
export const SET_COMBINE_WITH_ID = 'SET_COMBINE_WITH_ID';
export const SET_CALENDAR_PANEL_CONTAINER_WIDTH = 'SET_CALENDAR_PANEL_CONTAINER_WIDTH';
export const SET_ANIMATED_SIDEBAR_CONTAINER_WIDTH = 'SET_ANIMATED_SIDEBAR_CONTAINER_WIDTH';
export const SET_HEADER_HEIGHT = 'SET_HEADER_HEIGHT';
export const SET_IS_CALENDAR_OPTIONS_DROPDOWN_MENU_OPEN = 'SET_IS_CALENDAR_OPTIONS_DROPDOWN_MENU_OPEN';
export const SET_IS_STATIC_ADD_COLUMN_DROPDOWN_MENU_OPEN = 'SET_IS_STATIC_ADD_COLUMN_DROPDOWN_MENU_OPEN';
export const SET_IS_SUPERSET_PICKER_OPEN = 'SET_IS_SUPERSET_PICKER_OPEN';
export const SET_SUPERSET_PICKER_OPEN_BY_ID = 'SET_SUPERSET_PICKER_OPEN_BY_ID';
export const REMOVE_SUPERSET_PICKER_OPEN_BY_ID = 'REMOVE_SUPERSET_PICKER_OPEN_BY_ID';
export const FETCH_ALL_EXERCISES_START = 'FETCH_ALL_EXERCISES_START';
export const FETCH_ALL_EXERCISES_FULFILLED = 'FETCH_ALL_EXERCISES_FULFILLED';
export const FETCH_ALL_EXERCISES_REJECTED = 'FETCH_ALL_EXERCISES_REJECTED';
export const FETCH_EXERCISE_START = 'FETCH_ALL_EXERCISES_START';
export const FETCH_EXERCISE_FULFILLED = 'FETCH_EXERCISE_FULFILLED';
export const FETCH_EXERCISE_REJECTED = 'FETCH_EXERCISE_REJECTED';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';

export const SET_SELECTED_START_DAY_OF_WEEK = 'SET_SELECTED_START_DAY_OF_WEEK';
export const SET_SELECTED_NUMBER_OF_DAYS_TO_SHOW_IN_WEEK = 'SET_SELECTED_NUMBER_OF_DAYS_TO_SHOW_IN_WEEK';
export const SET_SELECTED_DAYS_OF_WEEK_TO_SHOW_IN_CURRENT_WEEK = 'SET_SELECTED_DAYS_OF_WEEK_TO_SHOW_IN_CURRENT_WEEK';
export const SET_GROUP_BY_FILTER = 'SET_GROUP_BY_FILTER';
export const SET_CURRENTLY_DISPLAYED_WEEKDAYS = 'SET_CURRENTLY_DISPLAYED_WEEKDAYS';
export const SET_SELECTED_WEEK_VIEW_DAY_TOGGLE = 'SET_SELECTED_WEEK_VIEW_DAY_TOGGLE';

export const SET_SELECTED_PROGRAM_DAY_NUMBER = 'SET_SELECTED_PROGRAM_DAY_NUMBER';
export const SET_SELECTED_MONTH = 'SET_SELECTED_MONTH';
export const FETCH_CALENDAR_ITEMS_START = 'FETCH_CALENDAR_ITEMS_START';
export const FETCH_CALENDAR_ITEMS_FULFILLED = 'FETCH_CALENDAR_ITEMS_FULFILLED';
export const FETCH_CALENDAR_ITEMS_REJECTED = 'FETCH_CALENDAR_ITEMS_REJECTED';
export const SET_SELECTED_REDUX_ATHLETE = 'SET_SELECTED_REDUX_ATHLETE';
export const SET_CALENDAR_CONTAINER_SCROLL_POSITION = 'SET_CALENDAR_CONTAINER_SCROLL_POSITION';
export const SET_ADD_INFO_CONTENT = 'SET_ADD_INFO_CONTENT';
export const SET_IFRAMELY_ERROR = 'SET_IFRAMELY_ERROR';
export const ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY = 'ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY';
export const ADD_PRESAVED_ITEM_TO_PROGRAM_ITEMS_ARRAY = 'ADD_PRESAVED_ITEM_TO_PROGRAM_ITEMS_ARRAY';
export const SET_ON_BEFORE_CAPTURE = 'SET_ON_BEFORE_CAPTURE';
export const SET_DISABLE_HORIZONTAL_SCROLLING_DURING_DRAG = 'SET_DISABLE_HORIZONTAL_SCROLLING_DURING_DRAG';
export const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS';
export const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM';
export const REMOVE_SELECTED_ITEM = 'REMOVE_SELECTED_ITEM';
export const SET_EXPANDED_ITEMS = 'SET_EXPANDED_ITEMS';
export const SET_EXPANDED_ITEM = 'SET_EXPANDED_ITEM';
export const REMOVE_EXPANDED_ITEM = 'REMOVE_EXPANDED_ITEM';
export const SET_WEEK_VIEW_EXPANDED_DAY = 'SET_WEEK_VIEW_EXPANDED_DAY';
export const FOCUS_NEXT_PRESAVE_ITEM = 'FOCUS_NEXT_PRESAVE_ITEM';
export const SET_CALENDAR_CONTENT_SCROLL_CONTAINER_TOP_POSITION = 'SET_CALENDAR_CONTENT_SCROLL_CONTAINER_TOP_POSITION';
export const SET_SIDE_BAR_EXERCISES_SEARCH_TERM = 'SET_SIDE_BAR_EXERCISES_SEARCH_TERM';
export const SET_EXERCISE_PICKER_SEARCH_TERM = 'SET_EXERCISE_PICKER_SEARCH_TERM';
/** upload media */
export const UPLOAD_CALENDAR_MEDIA_START = 'UPLOAD_CALENDAR_MEDIA_START';
export const UPLOAD_CALENDAR_MEDIA_FULFILLED = 'UPLOAD_CALENDAR_MEDIA_FULFILLED';
export const UPLOAD_CALENDAR_MEDIA_REJECTED = 'UPLOAD_CALENDAR_MEDIA_REJECTED';
export const UPLOAD_MEDIA_BY_URL_START = 'UPLOAD_MEDIA_BY_URL_START';
export const UPLOAD_MEDIA_BY_URL_FULFILLED = 'UPLOAD_MEDIA_BY_URL_FULFILLED';
export const UPLOAD_MEDIA_BY_URL_REJECTED = 'UPLOAD_MEDIA_BY_URL_REJECTED';
export const EDIT_THUMBNAIL_START = 'EDIT_THUMBNAIL_START';
export const EDIT_THUMBNAIL_FULFUILLED = 'EDIT_THUMBNAIL_FULFUILLED';
export const EDIT_THUMBNAIL_REJECTED = 'EDIT_THUMBNAIL_REJECTED';
/** create exercise */
export const CREATE_EXERCISE_START = 'CREATE_EXERCISE_START';
export const CREATE_EXERCISE_FULFILLED = 'CREATE_EXERCISE_FULFILLED';
export const CREATE_EXERCISE_REJECTED = 'CREATE_EXERCISE_REJECTED';
/** documents */
export const FETCH_DOCUMENTS_START = 'FETCH_DOCUMENTS_START';
export const FETCH_DOCUMENTS_FULFILLED = 'FETCH_DOCUMENTS_FULFILLED';
export const FETCH_DOCUMENTS_REJECTED = 'FETCH_DOCUMENTS_REJECTED';
export const FETCH_DOCUMENT_START = 'FETCH_DOCUMENT_START';
export const FETCH_DOCUMENT_FULFILLED = 'FETCH_DOCUMENT_FULFILLED';
export const FETCH_DOCUMENT_REJECTED = 'FETCH_DOCUMENT_REJECTED';
export const FETCH_FOLDER_START = 'FETCH_FOLDER_START';
export const FETCH_FOLDER_FULFILLED = 'FETCH_FOLDER_FULFILLED';
export const FETCH_FOLDER_REJECTED = 'FETCH_FOLDER_REJECTED';
export const ADD_ASSET = 'FETCH_ADD_ASSET';
export const SET_CLICKED_UPGRADE_NOW = 'SET_CLICKED_UPGRADE_NOW';
export const SET_NEW_PRESAVE_ITEM_FROM_CREATE_EXERCISE_FORM = 'SET_NEW_PRESAVE_ITEM_FROM_CREATE_EXERCISE_FORM';
/** tags */
export const FETCH_ACCOUNT_TAGS_START = 'FETCH_ACCOUNT_TAGS_START';
export const FETCH_ACCOUNT_TAGS_FULFILLED = 'FETCH_ACCOUNT_TAGS_FULFILLED';
export const FETCH_ACCOUNT_TAGS_REJECTED = 'FETCH_ACCOUNT_TAGS_REJECTED';
export const CREATE_TAG_FOR_ACCOUNT_START = 'CREATE_TAG_FOR_ACCOUNT_START';
export const CREATE_TAG_FOR_ACCOUNT_FULTILLED = 'CREATE_TAG_FOR_ACCOUNT_FULTILLED';
export const CREATE_TAG_FOR_ACCOUNT_REJECTED = 'CREATE_TAG_FOR_ACCOUNT_REJECTED';
/** questionnaires */
export const FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_START = 'FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_START';
export const FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED = 'FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED';
export const FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_REJECTED = 'FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_REJECTED';
export const CREATE_QUESTION_FOR_ACCOUNT_START = 'CREATE_QUESTION_FOR_ACCOUNT_START';
export const CREATE_QUESTION_FOR_ACCOUNT_FULTILLED = 'CREATE_QUESTION_FOR_ACCOUNT_FULTILLED';
export const CREATE_QUESTION_FOR_ACCOUNT_REJECTED = 'CREATE_QUESTION_FOR_ACCOUNT_REJECTED';
export const CLEAR_NEWLY_CREATED_QUESTION = 'CLEAR_NEWLY_CREATED_QUESTION';
export const SET_QUESTION_COUNT = 'SET_QUESTION_COUNT';
export const SET_DELETE_STACK = 'SET_DELETE_STACK';
export const SET_CALENDAR_ITEMS = 'SET_CALENDAR_ITEMS';
export const SET_NON_DATE_BASED_PROGRAM_ITEMS = 'SET_NON_DATE_BASED_PROGRAM_ITEMS';
export const SET_NON_DATE_BASED_PROGRAM_DAYS = 'SET_NON_DATE_BASED_PROGRAM_DAYS';
export const SET_RECURRING_CALENDAR_ITEMS = 'SET_RECURRING_CALENDAR_ITEMS';
export const CLEAR_BEFORE_RECURRING_CALENDAR_ITEMS = 'CLEAR_BEFORE_RECURRING_CALENDAR_ITEMS';
export const CLEAR_AFTER_RECURRING_CALENDAR_ITEMS = 'CLEAR_AFTER_RECURRING_CALENDAR_ITEMS';
export const CLEAR_CALENDAR_ITEMS = 'CLEAR_CALENDAR_ITEMS';
export const CLEAR_NON_DATE_BASED_PROGRAM_ITEMS = 'CLEAR_NON_DATE_BASED_PROGRAM_ITEMS';

export const REMOVE_PRESAVE_ITEM_FROM_REDUX = 'REMOVE_PRESAVE_ITEM_FROM_REDUX';
export const REMOVE_PRESAVE_PROGRAM_ITEM_FROM_REDUX = 'REMOVE_PRESAVE_PROGRAM_ITEM_FROM_REDUX';
export const LOG_REDUX_PRESAVE_ADD_INFO = 'LOG_REDUX_PRESAVE_ADD_INFO';
export const LOG_REDUX_PRESAVE_DESCRIPTION = 'LOG_REDUX_PRESAVE_DESCRIPTION';

export const SET_IS_DRAGGING = 'SET_IS_DRAGGING';
export const SET_DRAG_SOURCE = 'SET_DRAG_SOURCE';
export const SET_PLACEHOLDER_INFO = 'SET_PLACEHOLDER_INFO';
export const SET_DRAG_IS_IN_PROGRESS = 'SET_DRAG_IS_IN_PROGRESS';
export const SET_DROPPABLE_CONTAINER_CURRENTLY_HOVERED_BY_DRAGGED_ITEM = 'SET_DROPPABLE_CONTAINER_CURRENTLY_HOVERED_BY_DRAGGED_ITEM';
export const SET_DRAGGED_ITEM = 'SET_DRAGGED_ITEM';
export const SET_REDUX_CALENDAR_CONTAINERS = 'SET_REDUX_CALENDAR_CONTAINERS';
export const SET_PROGRAMMED_CALENDAR_ITEMS = 'SET_PROGRAMMED_CALENDAR_ITEMS';

export const FETCH_SAVED_WORKOUTS_START = 'FETCH_SAVED_WORKOUTS_START';
export const FETCH_SAVED_WORKOUTS_FULFILLED = 'FETCH_SAVED_WORKOUTS_FULFILLED';
export const FETCH_SAVED_WORKOUTS_REJECTED = 'FETCH_SAVED_WORKOUTS_REJECTED';

export const FETCH_PROGRAMMED_CALENDAR_ITEM_START = 'FETCH_PROGRAMMED_CALENDAR_ITEM_START ';
export const FETCH_PROGRAMMED_CALENDAR_ITEM_FULFILLED = 'FETCH_PROGRAMMED_CALENDAR_ITEM_FULFILLED';
export const FETCH_PROGRAMMED_CALENDAR_ITEM_REJECTED = 'FETCH_PROGRAMMED_CALENDAR_ITEM_REJECTED';

export const FETCH_SAVED_WORKOUT_DETAIL_START = 'FETCH_SAVED_WORKOUT_DETAIL_START';
export const FETCH_SAVED_WORKOUT_DETAIL_FULFILLED = 'FETCH_SAVED_WORKOUT_DETAIL_FULFILLED';
export const FETCH_SAVED_WORKOUT_DETAIL_REJECTED = 'FETCH_SAVED_WORKOUT_DETAIL_REJECTED';

export const FETCH_SAVED_WORKOUT_START = 'FETCH_SAVED_WORKOUT_START';
export const FETCH_SAVED_WORKOUT_FULFILLED = 'FETCH_SAVED_WORKOUT_FULFILLED';
export const FETCH_SAVED_WORKOUT_REJECTED = 'FETCH_SAVED_WORKOUT_REJECTED';

export const SET_SELECTED_SAVED_WORKOUT = 'SET_SELECTED_SAVED_WORKOUT';
export const LOAD_SAVED_PROGRAM_START = 'LOAD_SAVED_PROGRAM_START';
export const LOAD_SAVED_PROGRAM_FULFILLED = 'LOAD_SAVED_PROGRAM_FULFILLED';
export const LOAD_SAVED_PROGRAM_REJECTED = 'LOAD_SAVED_PROGRAM_REJECTED';

export const SET_COMBINE_WITH_INFO = 'SET_COMBINE_WITH_INFO';
export const SET_SUPERSET_PICKER = 'SET_SUPERSET_PICKER';

export const SET_IS_BEFORE_RECURRING_SECTION_EXPANDED = 'SET_IS_BEFORE_RECURRING_SECTION_EXPANDED';
export const SET_IS_AFTER_RECURRING_SECTION_EXPANDED = 'SET_IS_AFTER_RECURRING_SECTION_EXPANDED';

export const SET_LAST_UPDATE_TIME = 'SET_LAST_UPDATE_TIME';

export const UPDATE_WORKOUT_INFO_NAME_START = 'UPDATE_WORKOUT_INFO_NAME_START';
export const UPDATE_WORKOUT_INFO_NAME_FULFILLED = 'UPDATE_WORKOUT_INFO_NAME_FULFILLED';
export const UPDATE_WORKOUT_INFO_NAME_REJECTED = 'UPDATE_WORKOUT_INFO_NAME_REJECTED';

export const UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_START = 'UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_START';
export const UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_FULFILLED = 'UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_FULFILLED';
export const UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_REJECTED = 'UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_REJECTED';

export const UPDATE_NON_DATE_BASED_WORKOUT_INFO_COLOR_START = 'UPDATE_NON_DATE_BASED_WORKOUT_INFO_COLOR_START';
export const UPDATE_NON_DATE_BASED_WORKOUT_INFO_COLOR_FULFILLED = 'UPDATE_NON_DATE_BASED_WORKOUT_INFO_COLOR_FULFILLED';
export const UPDATE_NON_DATE_BASED_WORKOUT_INFO_COLOR_REJECTED = 'UPDATE_NON_DATE_BASED_WORKOUT_INFO_COLOR_REJECTED';

export const TOGGLE_ANALYTICS_STRIKETHROUGH = 'TOGGLE_ANALYTICS_STRIKETHROUGH';

export const UPDATE_WORKOUT_INFO_COLOR_START = 'UPDATE_WORKOUT_INFO_COLOR_START';
export const UPDATE_WORKOUT_INFO_COLOR_FULFILLED = 'UPDATE_WORKOUT_INFO_COLOR_FULFILLED';
export const UPDATE_WORKOUT_INFO_COLOR_REJECTED = 'UPDATE_WORKOUT_INFO_COLOR_REJECTED';

export const SAVE_WORKOUT_TEMPLATE = 'SAVE_WORKOUT_TEMPLATE';
export const SAVE_WORKOUT_TEMPLATE_FULFILLED = 'SAVE_WORKOUT_TEMPLATE_FULFILLED';
export const SAVE_WORKOUT_TEMPLATE_REJECTED = 'SAVE_WORKOUT_TEMPLATE_REJECTED';

export const SHARE_WORKOUT_INFO_START = 'SHARE_WORKOUT_INFO_START';
export const SHARE_WORKOUT_INFO_FULFILLED = 'SHARE_WORKOUT_INFO_FULFILLED';
export const SHARE_WORKOUT_INFO_REJECTED = 'SHARE_WORKOUT_INFO_REJECTED';

export const CLEAR_WORKOUT_ITEMS_START = 'CLEAR_WORKOUT_ITEMS_START';
export const CLEAR_WORKOUT_ITEMS_FULFILLED = 'CLEAR_WORKOUT_ITEMS_FULFILLED';
export const CLEAR_WORKOUT_ITEMS_REJECTED = 'CLEAR_WORKOUT_ITEMS_REJECTED';

export const COPY_WORKOUT_ITEMS_START = 'COPY_WORKOUT_ITEMS_START';
export const COPY_WORKOUT_ITEMS_FULFILLED = 'COPY_WORKOUT_ITEMS_FULFILLED';
export const COPY_WORKOUT_ITEMS_REJECTED = 'COPY_WORKOUT_ITEMS_REJECTED';

export const REVERT_LAST_KNOWN_CORRECT_ORDER = 'REVERT_LAST_KNOWN_CORRECT_ORDER';
export const REVERT_LAST_KNOWN_CORRECT_ORDER_FOR_SAVED_WORKOUT = 'REVERT_LAST_KNOWN_CORRECT_ORDER_FOR_SAVED_WORKOUT';

export const FETCH_CALENDAR_PICKER_ITEMS_START = 'FETCH_CALENDAR_PICKER_ITEMS_START';
export const FETCH_CALENDAR_PICKER_ITEMS_FULFILLED = 'FETCH_CALENDAR_PICKER_ITEMS_FULFILLED';
export const FETCH_CALENDAR_PICKER_ITEMS_REJECTED = 'FETCH_CALENDAR_PICKER_ITEMS_REJECTED';

export const UPDATE_CALENDAR_SETTINGS_START = 'UPDATE_CALENDAR_SETTINGS_START';
export const UPDATE_CALENDAR_SETTINGS_FULFILLED = 'UPDATE_CALENDAR_SETTINGS_FULFILLED';
export const UPDATE_CALENDAR_SETTINGS_REJECTED = 'UPDATE_CALENDAR_SETTINGS_REJECTED';

export const SET_VIEW_TYPE = 'SET_VIEW_TYPE';
export const SET_PROGRAM_TYPE = 'SET_PROGRAM_TYPE';

export const FETCH_AND_SET_DEFAULT_CALENDAR_START = 'FETCH_AND_SET_DEFAULT_CALENDAR_START';
export const FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED = 'FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED';
export const FETCH_AND_SET_DEFAULT_CALENDAR_REJECTED = 'FETCH_AND_SET_DEFAULT_CALENDAR_REJECTED';

export const FETCH_AND_SET_URL_ATHLETE_START = 'FETCH_AND_SET_URL_ATHLETE_START';
export const FETCH_AND_SET_URL_ATHLETE_FULFILLED = 'FETCH_AND_SET_URL_ATHLETE_FULFILLED';
export const FETCH_AND_SET_URL_ATHLETE_REJECTED = 'FETCH_AND_SET_URL_ATHLETE_REJECTED';

export const CREATE_PARENT_CALENDAR_START = 'CREATE_PARENT_CALENDAR_START';
export const CREATE_PARENT_CALENDAR_FULFILLED = 'CREATE_PARENT_CALENDAR_FULFILLED';
export const CREATE_PARENT_CALENDAR_REJECTED = 'CREATE_PARENT_CALENDAR_REJECTED';

export const CREATE_PARENT_CHILD_CALENDAR_START = 'CREATE_PARENT_CHILD_CALENDAR_START';
export const CREATE_PARENT_CHILD_CALENDAR_FULFILLED = 'CREATE_PARENT_CHILD_CALENDAR_FULFILLED';
export const CREATE_PARENT_CHILD_CALENDAR_REJECTED = 'CREATE_PARENT_CHILD_CALENDAR_REJECTED';
export const CLEAR_MOST_RECENTLY_ADDED_CALENDAR_ITEM_TRACKER = 'CLEAR_MOST_RECENTLY_ADDED_CALENDAR_ITEM_TRACKER';

export const FETCH_WORKOUT_TEMPLATE_DATA_START = 'FETCH_WORKOUT_TEMPLATE_DATA_START';
export const FETCH_WORKOUT_TEMPLATE_DATA_FULFILLED = 'FETCH_WORKOUT_TEMPLATE_DATA_FULFILLED';
export const FETCH_WORKOUT_TEMPLATE_DATA_REJECTED = 'FETCH_WORKOUT_TEMPLATE_DATA_REJECTED';

// Namespaced action types for week view support
export const SET_CALENDAR_ITEMS_NAMESPACED = 'SET_CALENDAR_ITEMS_NAMESPACED';
export const UPDATE_CALENDAR_ITEMS_ORDER_START_NAMESPACED = 'UPDATE_CALENDAR_ITEMS_ORDER_START_NAMESPACED';
export const UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED_NAMESPACED = 'UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED_NAMESPACED';
export const UPDATE_CALENDAR_ITEMS_ORDER_REJECTED_NAMESPACED = 'UPDATE_CALENDAR_ITEMS_ORDER_REJECTED_NAMESPACED';
export const ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY_NAMESPACED = 'ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY_NAMESPACED';
export const SET_COMBINE_WITH_INFO_NAMESPACED = 'SET_COMBINE_WITH_INFO_NAMESPACED';

// PreSaveTable local state backup
export const SET_PRESAVE_TABLE_LOCAL_STATE = 'SET_PRESAVE_TABLE_LOCAL_STATE';
export const REMOVE_PRESAVE_TABLE_LOCAL_STATE = 'REMOVE_PRESAVE_TABLE_LOCAL_STATE';
export const CLEAR_PRESAVE_TABLE_LOCAL_STATE = 'CLEAR_PRESAVE_TABLE_LOCAL_STATE';
